import { SimplePieChartWithPaddingAngle } from "../Global/SimplePieChartWithPaddingAngle"

export const SimplePieChartWithPaddingAngleWidget = (props) => {
    return(
        <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center', marginTop: '10px', width: 'inherit', height: '15vh'}}>
            <SimplePieChartWithPaddingAngle value={props.value}/>
            <p style={{fontWeight: 'bold', color: '#659767', margin: '0', fontSize: 'small'}}>{props.label}</p>
        </div>
    )
}